import { Translate } from '@chipinside/translate'
import { Button, DialogActions, IconButton, styled, Tooltip } from '@mui/material'
import { isEmpty } from 'lodash'
import React from 'react'

import { Icon } from '#/components/Icon'
import { useFarmSlug } from '#/store/ducks/farm'
import { endpoint } from '#/store/services/endpoints'
import { handleDownload } from '#/utils/download'

const FooterContainer = styled(DialogActions)({
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: 0,
})

const DownloadButton = styled(Button)(({ theme }) => ({
  'marginLeft': 5,
  '& .download-label': {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}))

export default function JobDetailFooter(props) {
  const farmSlug = useFarmSlug()
  const { jobSlug, has_result_file, has_file, result } = props

  const unprocessed = result
    ?.filter(({ status }) => status?.status === 'failed')
    .map(({ identifier }) => identifier)

  const copyFailedCTech = () => {
    return navigator.clipboard.writeText(unprocessed.join(', '))
  }

  /**
   * This code block is rendering a button to copy the list of failed job identifiers
   * to the clipboard if there are any failed jobs in the `result` array.
   * */
  const CopyButton = () => {
    if (!isEmpty(unprocessed)) {
      return (
        <Tooltip title={Translate({ messageKey: 'copy_unprocessed' })}>
          <IconButton onClick={copyFailedCTech}>
            <Icon size="large" name="content-copy" />
          </IconButton>
        </Tooltip>
      )
    }
    return null
  }

  const controllers = farmSlug
    ? {
        result: endpoint.farm.job.result({ farm: farmSlug, job: jobSlug }),
        file: endpoint.farm.job.file({ farm: farmSlug, job: jobSlug }),
      }
    : {
        result: endpoint.job.result({ job: jobSlug }),
        file: endpoint.job.file({ job: jobSlug }),
      }

  /**
   * Create footer buttons
   */
  let footer = []
  if (has_result_file) {
    footer.push({
      label: Translate({ messageKey: 'download_results' }),
      icon: 'file-download',
      onClick: () => handleDownload({ controller: controllers.result }),
    })
  }
  if (has_file) {
    footer.push({
      label: Translate({ messageKey: 'download_file' }),
      icon: 'mdi-download',
      onClick: () => handleDownload({ controller: controllers.file }),
    })
  }

  if (isEmpty(footer)) return null

  return (
    <FooterContainer>
      <CopyButton />
      {footer.map(btn => (
        <Tooltip title={btn.label} key={btn.label}>
          <DownloadButton color="secondary" variant="outlined" onClick={btn.onClick}>
            <span className="download-label">{btn.label}</span>
            <Icon size="large" name={btn.icon} />
          </DownloadButton>
        </Tooltip>
      ))}
    </FooterContainer>
  )
}
